import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const testimonials = [{
  initials: 'CR',
  name: 'Carlos R.',
  location: 'Mendoza',
  product: 'Mega Kit + Off-Road CEO',
  quote: 'El sistema de Nodos me liberó de 30 consultas por día. Ahora el equipo decide solo el 80% de las cosas. Por fin tengo tiempo para pensar en la empresa.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  product: 'Mega Kit',
  quote: 'Finanzas de Guerra me mostró una fuga de caja que no estaba viendo. Recuperé el equivalente a 2 meses de facturación en 60 días.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  product: 'Mega Kit',
  quote: 'La Auditoría 360 me mostró que mi problema no era de ventas sino de procesos. En 30 días reorganicé todo y las ventas subieron solas.'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Neuquén',
  product: 'Mega Kit + Off-Road CEO',
  quote: 'El Protocolo del Viernes Off fue el primer día en 4 años que no revisé el teléfono. Y la empresa no se cayó. Eso fue un antes y un después.'
}];
const faqs = [{
  q: '¿Sirve para cualquier tipo de PyME?',
  a: 'Sí. El sistema está diseñado para PyMEs de servicios, comerciales y productivas de entre 2 y 50 personas. Los casos prácticos incluyen ejemplos de ambos tipos para que puedas adaptar cada herramienta a tu contexto.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. En menos de 5 minutos después de tu pago recibís el acceso a todos los PDFs por email. Sin esperas, sin envíos físicos, sin instalaciones.'
}, {
  q: '¿Lo puedo implementar solo o necesito un equipo grande?',
  a: 'Podés empezar solo. De hecho, el Bono 1 (Mapa de Arranque Rápido) está diseñado exactamente para eso: darte un plan de las primeras 72 horas para que empieces a implementar sin abrumarte con todo el sistema de golpe.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días sin preguntas. Si abrís el material y no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios, sin demoras, sin drama.'
}];
const costComparison = [{
  sin: '3 horas diarias tomando decisiones que otros podrían tomar',
  costo: '60 horas de tu vida por mes'
}, {
  sin: 'Sin sistema de reuniones',
  costo: 'Horas perdidas en conversaciones que no producen decisiones'
}, {
  sin: 'Sin control financiero semanal',
  costo: 'Fugas de caja que descubrís cuando ya es tarde'
}, {
  sin: 'Sin proceso de delegación',
  costo: 'Dependencia total del dueño que frena el crecimiento'
}, {
  sin: 'Sin estrategia de 90 días',
  costo: 'Trabajás mucho pero no sabés si avanzás'
}, {
  sin: 'Próximo lunes sin sistema',
  costo: 'El mismo ciclo, el próximo año'
}];
function FaqItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="bg-[#0a0f1a] border border-gray-800 rounded-2xl overflow-hidden" data-id="element-195">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-5 md:p-6 text-left font-bold text-base md:text-lg text-white hover:text-emerald-500 transition-colors" data-id="element-196">
        <span data-id="element-197">{q}</span>
        <svg className={`w-5 h-5 text-gray-500 shrink-0 ml-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-198">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-199" />
        </svg>
      </button>
      {open && <div className="px-5 md:px-6 pb-5 md:pb-6 text-gray-400 leading-relaxed text-sm md:text-base border-t border-gray-800/50" data-id="element-200">
          <div className="pt-4" data-id="element-201">{a}</div>
        </div>}
    </div>;
}
export function TrustSection() {
  const [showOptions, setShowOptions] = useState(false);
  return <section className="py-16 md:py-24 bg-[#1F1A17] border-t border-gray-800" data-id="element-202">
      <div className="max-w-6xl mx-auto px-4" data-id="element-203">
        {/* Testimonials */}
        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-16" data-id="element-204">
          ❤️ MÁS DUEÑOS QUE YA LO TIENEN
        </h2>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-205">
          {testimonials.map((t, i) => <div key={i} className="bg-[#0a0f1a] border border-gray-800 rounded-2xl p-6 md:p-8" data-id="element-206">
              <div className="flex items-center gap-3 md:gap-4 mb-5" data-id="element-207">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-emerald-500/10 text-emerald-500 flex items-center justify-center font-bold text-base md:text-xl border border-emerald-500/20" data-id="element-208">
                  {t.initials}
                </div>
                <div data-id="element-209">
                  <div className="text-emerald-500 text-xs tracking-wider mb-0.5" data-id="element-210">
                    ★★★★★
                  </div>
                  <div className="text-white font-bold text-sm md:text-base" data-id="element-211">
                    {t.name}{' '}
                    <span className="text-gray-500 font-normal text-xs md:text-sm ml-1" data-id="element-212">
                      📍 {t.location}
                    </span>
                  </div>
                  <div className="text-xs text-emerald-500/80 font-medium mt-0.5" data-id="element-213">
                    | {t.product}
                  </div>
                </div>
              </div>
              <p className="text-gray-300 italic text-sm md:text-lg leading-relaxed" data-id="element-214">
                "{t.quote}"
              </p>
            </div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-gray-800 to-gray-900 border border-gray-700 rounded-2xl md:rounded-3xl p-8 md:p-14 text-center mb-20 md:mb-28 relative overflow-hidden" data-id="element-215">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-emerald-500" data-id="element-216" />
          <div className="text-6xl md:text-7xl mb-6" data-id="element-217">🛡️</div>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-5" data-id="element-218">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-base md:text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-219">
            Abrís los tomos. Los implementás en tu empresa.
            <br data-id="element-220" />
            Si en 7 días no es lo que esperabas:
            <br data-id="element-221" />
            <strong className="text-white" data-id="element-222">devolución del 100%</strong>
            <br data-id="element-223" />
            sin formularios, sin drama.
          </p>
          <div className="inline-block bg-[#0a0f1a] px-5 py-2.5 rounded-full text-emerald-500 font-medium border border-gray-800 text-sm" data-id="element-224">
            Tasa de devoluciones: menos del 1%.
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto mb-20 md:mb-28" data-id="element-225">
          <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-12" data-id="element-226">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="space-y-3 md:space-y-4" data-id="element-227">
            {faqs.map((faq, i) => <FaqItem key={i} q={faq.q} a={faq.a} data-id="element-228" />)}
          </div>
        </div>

        {/* Cost Comparison */}
        <div className="max-w-4xl mx-auto mb-20 md:mb-28" data-id="element-229">
          <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-12" data-id="element-230">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
          <div className="bg-[#0a0f1a] border border-gray-800 rounded-2xl md:rounded-3xl overflow-hidden" data-id="element-231">
            <div className="overflow-x-auto" data-id="element-232">
              <table className="w-full text-left min-w-[500px]" data-id="element-233">
                <thead data-id="element-234">
                  <tr className="bg-gray-800/60" data-id="element-235">
                    <th className="p-4 md:p-6 text-gray-300 font-semibold text-sm border-b border-gray-700 w-1/2" data-id="element-236">
                      Sin Mega Kit
                    </th>
                    <th className="p-4 md:p-6 text-red-400 font-semibold text-sm border-b border-gray-700 w-1/2" data-id="element-237">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-238">
                  {costComparison.map((row, i) => <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/20 transition-colors" data-id="element-239">
                      <td className="p-4 md:p-6 text-white font-medium text-sm" data-id="element-240">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-gray-400 text-sm" data-id="element-241">
                        {row.costo}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="max-w-4xl mx-auto text-center bg-[#0a0f1a] border border-emerald-500/30 rounded-2xl md:rounded-3xl p-6 md:p-14 relative overflow-hidden" data-id="element-242">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-xl h-[250px] rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(16,185,129,0.06) 0%, transparent 70%)'
        }} data-id="element-243" />

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 relative z-10" data-id="element-244">
            El próximo lunes puede ser diferente.
          </h2>

          <div className="mb-10 relative z-10" data-id="element-245">
            <div className="text-red-500 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-246">
              ⏰ EL PRECIO CIERRA EN:
            </div>
            <CountdownTimer data-id="element-247" />
          </div>

          <div className="flex flex-col md:flex-row gap-4 md:gap-6 justify-center relative z-10 mb-10" data-id="element-248">
            {!showOptions ? <button onClick={() => setShowOptions(true)} className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-12 py-6 text-xl md:text-2xl font-bold text-gray-950 bg-emerald-500 hover:bg-emerald-400 rounded-2xl transition-all active:scale-95" data-id="element-249">
                → VER OPCIONES DE COMPRA
              </button> : <>
                <a href="https://www.nexorecursos.com/cart/52429049331988:1" className="animate-fade-in-up flex-1 bg-gray-800 hover:bg-gray-700 text-white font-bold py-5 px-6 rounded-2xl transition-colors border border-gray-700 flex flex-col items-center justify-center gap-1" data-id="element-250">
                  <span className="text-lg md:text-xl" data-id="element-251">MEGA KIT</span>
                  <span className="text-emerald-500 font-bold" data-id="element-252">
                    $19.990 ARS
                  </span>
                  <span className="text-xs font-normal text-gray-400 mt-1" data-id="element-253">
                    → QUIERO MI MEGA KIT
                  </span>
                </a>
                <a href="https://www.nexorecursos.com/cart/52429003817236:1" className="animate-fade-in-up animate-pulse-glow flex-1 bg-emerald-500 hover:bg-emerald-400 text-gray-950 font-bold py-5 px-6 rounded-2xl transition-all active:scale-95 flex flex-col items-center justify-center gap-1" data-id="element-254">
                  <span className="text-lg md:text-xl" data-id="element-255">
                    MEGA KIT + OFF-ROAD CEO ⭐
                  </span>
                  <span className="text-gray-900 font-bold" data-id="element-256">$27.990 ARS</span>
                  <span className="text-xs font-bold text-gray-800 mt-1" data-id="element-257">
                    → QUIERO EL MEGA KIT + OFF-ROAD CEO
                  </span>
                </a>
              </>}
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm font-medium text-gray-500 relative z-10" data-id="element-258">
            <span data-id="element-259">🔒 Pago 100% seguro</span>
            <span data-id="element-260">⚡ Acceso en 5 minutos</span>
            <span data-id="element-261">🛡️ Garantía 7 días</span>
            <span data-id="element-262">💳 Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}